import React from 'react';
import {Button, withStyles} from "material-ui";
import Dropzone from 'react-dropzone';
import grey from "material-ui/colors/grey";
import AddIcon from 'material-ui-icons/AddAPhoto';
import SectionImages from "../../containers/builder/form/section_images";
import swal from 'sweetalert';

const styles = theme => ({
    chip: {
        margin: '0 10px 20px 0',
    },
    svgIcon: {
        color: grey[800],
    },
    row: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    buttonIconSmall: {
        width: 20,
        height: 20,
        marginLeft: 5
    },
});

class DropzoneImageField extends React.Component {

    constructor() {
        super();
        this.state = {
            dropzoneActive: false,
        }
        this.onDragEnter = this.onDragEnter.bind(this);
        this.onDragLeave = this.onDragLeave.bind(this);
    }

    onDragEnter() {
        this.setState({
            dropzoneActive: true
        });
    }

    onDragLeave() {
        this.setState({
            dropzoneActive: false
        });
    }

    render() {

        const {dropzoneActive} = this.state;

        const {images, onImageDelete, onImageClick, onImagesDrop, classes, multiple} = this.props;

        const overlayStyle = {
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            padding: '2.5em 0',
            background: 'rgba(0,0,0,0.5)',
            textAlign: 'center',
            color: '#9dffe2'
        };

        let dropzoneRef;

        let image = this.props.images != null ? this.props.images : {};

        return (
            <div>
                <Dropzone
                    disableClick
                    multiple={multiple}
                    style={{position: "relative"}}
                    accept="image/jpeg, image/png"
                    onDrop={(images) => {
                        onImagesDrop(images);
                        this.setState({
                            dropzoneActive: false
                        });
                        if (!multiple && image.new === false) {
                            swal("Attention", "Please note you are replacing the old image!", "warning")
                        }
                        if (images.length > 5) {
                            swal("Attention", "Please note you should only upload 5 images!", "warning")
                        }
                    }}
                    onDragEnter={this.onDragEnter}
                    onDragLeave={this.onDragLeave}
                    ref={(node) => {dropzoneRef = node; }}
                >
                    {dropzoneActive && <div style={overlayStyle}>Drop image(s)...</div>}

                    <div>
                        <h3>{multiple ? 'Upload Images' : 'Upload Image'}</h3>
                        {!multiple && <h4 className="errMsg">Please note you can drag ONE image and if you choose more, only the first image will be selected!</h4>}
                        <h4>Drop {multiple ? 'files' : 'file'} here or click the button to select {multiple ? 'images' : 'image'}.</h4>
                        <h4>Click on the image name if you wish to crop the photo or add meta info to it!</h4>
                        <div className={classes.row}>
                            <SectionImages
                                images={images}
                                onImageDelete={onImageDelete}
                                onImageClick={onImageClick}
                                classes={classes}
                            />
                        </div>
                    </div>
                </Dropzone>
                <Button size="small" color="default" variant="raised" onClick={() => {dropzoneRef.open() }} className={classes.buttonAdd}>
                    {multiple ? 'Open Files' : 'Open File'}
                    <AddIcon className={classes.buttonIconSmall}/>
                </Button>
            </div>
        )
    }
}

export default withStyles(styles)(DropzoneImageField);


// WEBPACK FOOTER //
// ./src/components/fields/field_dropzone_image.js